import { Logo, Surface, Txt } from '@vst/beam';
import { ViasatLogoDefault } from '@vst/beam-icons/logos/viasat';
import { useTranslation } from 'react-i18next';

import { PageFooter } from '@app/components/PageFooter';

import MaintenanceImage from './maintenance-image';

import styles from './index.module.scss';

export const Maintenance = (): JSX.Element => {
  const { t } = useTranslation('Maintenance');

  return (
    <Surface variant="gradientPrimary1">
      <Surface className={styles['container']} variant="secondary">
        <Surface className={styles['header']}>
          <div>
            <Logo logo={ViasatLogoDefault} alt="Viasat" size="112px" />
          </div>
        </Surface>
        <Surface className={styles['body']}>
          <MaintenanceImage />
          <Txt variant="heading4" style={{ paddingBottom: 12, paddingTop: 16 }}>
            {t('title')}
          </Txt>
          <Txt variant="bodyLargeRegular">{t('body')}</Txt>
        </Surface>
        <Surface />
        <PageFooter />
      </Surface>
    </Surface>
  );
};
